export default `
  mutation CreateSession($input: CreateSessionInput) {
    createSession(input: $input)
  }
`;
